import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useAuthStore from "store/authStore";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFreeBooksQuota = () => {
	const { loggedIn } = useAuthStore();
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		if (!loggedIn) {
			return null;
		}

		const instance = await InitApi({ accessToken });
		const res = await instance.get("books/free-books-quota");
		return res?.data;
	};

	return useQuery("free_books_quota", () => fetch(), {
		...fetchConfig,
		enabled: loggedIn,
	});
};

export default useFreeBooksQuota;
